import React from 'react';
import PropTypes from 'prop-types';
import Accordion from '@components/@core/Accordion';
import Col from 'react-bootstrap/Col';
import Dropdown from '@components/@core/Dropdown';
import Row from 'react-bootstrap/Row';
import Input from '@components/@core/Input';
import { getSettings } from '~/services/util';

const Settings = ({ isEditable = false, expanded = false, values = [], stats = [], handleSelect, ...props }) => {
    return (
        <div className="detail-settings mt-3 mb-2">
            <Accordion expanded={expanded} className="settings-quota" icon={null} title="Settings">
                <Row>
                    <Col xs={12} sm={12} className="py-4">
                        <Row>
                            {!isEditable
                                ? values.map((value) => (
                                      <Col xs={12} sm={12} className="my-1" key={value.name}>
                                          <Input disabled={true} className="input-field" title={value.name} value={getSettings(value.id, value.options, 'Na')} />
                                      </Col>
                                  ))
                                : values.map((value) => (
                                      <Col xs={12} sm={12} className="my-1" key={value.name}>
                                          <Dropdown
                                              className="dropdown-field author"
                                              title={value.name}
                                              width="fit-content"
                                              multi={value.name !== 'Author'}
                                              defaultIds={value.id}
                                              data={value.options}
                                              getValue={(e) => e.name}
                                              onChange={handleSelect(value.select)}
                                          />
                                      </Col>
                                  ))}
                        </Row>
                    </Col>
                </Row>
                {stats.length > 0 && (
                    <>
                        <div className="divider mx-3 border-top"></div>
                        <Row>
                            <Col xs={12} sm={12} className="py-4">
                                <Row>
                                    {stats.map((value) => (
                                        <Col xs={12} sm={12} className="my-1" key={value.name}>
                                            <Input disabled className="input-field" title={value.name} value={value.value} />
                                        </Col>
                                    ))}
                                </Row>
                            </Col>
                        </Row>
                    </>
                )}
            </Accordion>
        </div>
    );
};

Settings.propTypes = {
    isEditable: PropTypes.bool,
    values: PropTypes.array,
    stats: PropTypes.array,
};

export default Settings;
